import { IsString, IsArray, IsBoolean, IsInt, MaxLength, ArrayMaxSize, IsNumber, Validate, ValidatorConstraint, ValidatorConstraintInterface, ValidationArguments } from "class-validator";
import { Type } from "class-transformer";

@ValidatorConstraint({ name: 'strokeArray', async: false })
export class StrokeArray implements ValidatorConstraintInterface {
  validate(value: [number, number][][], args: ValidationArguments) {
    if (value.length > 200) {
        return false;
    }
    for (let line of value) {
        if (value.length > 2000) {
            return false;
        }
        for (let point of line) {
            if (point.length !== 2) {
                return false;
            }
        }
    }
    return true;
  }

  defaultMessage(args: ValidationArguments) {
    return 'Strokes are invalid';
  }
}

export class AbcCharactersHandwritingSearchParamsDto {
    @Validate(StrokeArray)
	@ArrayMaxSize(200)
	@IsArray()
	strokes?: [number, number][][];
}

export class AbcCharactersHandwritingSearchResultDto {
	results: {
        symbol: string,
        score?: number
    }[]
}
